module.exports = __webpack_public_path__ + "static/media/radio_traditional_deselected.1d6719ea.svg";